export default __webpack_public_path__ + "static/media/noa-16.96d185fe.jpg";